import {EdgeType} from '@PosterWhiteboard/classes/item-effects.class';

export interface EdgeEffectOptionsData {
  effect: EdgeType;
  thumbnail: string;
}

export const EdgeEffectOptionsDataArray: Array<EdgeEffectOptionsData> = [
  {
    effect: EdgeType.NONE,
    thumbnail: 'none',
  },
  {
    effect: EdgeType.OVAL,
    thumbnail: 'oval',
  },
  {
    effect: EdgeType.RECTANGLE,
    thumbnail: 'rectangle',
  },
  {
    effect: EdgeType.GRADIENT,
    thumbnail: 'gradient',
  },
  {
    effect: EdgeType.SCRATCHED,
    thumbnail: 'scratched',
  },
  {
    effect: EdgeType.TORN_PAPER,
    thumbnail: 'torn_paper',
  },
  {
    effect: EdgeType.CIRCULAR,
    thumbnail: 'circular',
  },
  {
    effect: EdgeType.HEART,
    thumbnail: 'heart',
  },
];
